
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $cP3LP = parcelRequire("cP3LP");
document.addEventListener("DOMContentLoaded", ()=>{
    const newForm = document.getElementById("new-ticket-form");
    const checkForm = document.getElementById("check-status-form");
    const ticketResults = document.getElementById("ticket-results");
    const overlay = document.getElementById("chat-overlay");
    const chatMessages = document.getElementById("chat-messages");
    const replyForm = document.getElementById("reply-form");
    const nameInput = document.querySelector('input[name="name"]');
    const emailInput = document.querySelector('input[name="email"]');
    let activeTicketId = null;
    let activeEmail = null;
    // Auto-fill check email from local storage
    if (document.getElementById("check-email")) document.getElementById("check-email").value = localStorage.getItem("last_checked_email") || "";
    // Submit New Ticket
    newForm.addEventListener("submit", async (e)=>{
        e.preventDefault();
        const formData = new FormData(newForm);
        const data = Object.fromEntries(formData.entries());
        if (!data.email || !data.name) {
            (0, $cP3LP.showToast)("Please provide your name and email so we can reach you.", "warning");
            return;
        }
        (0, $cP3LP.showGlobalPreloader)("Submitting ticket...");
        const headers = {
            "Content-Type": "application/json"
        };
        try {
            const response = await fetch("/api/tickets", {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data)
            });
            const result = await response.json();
            if (response.ok) {
                (0, $cP3LP.showToast)("Ticket submitted successfully!", "success");
                newForm.reset();
                if (nameInput) nameInput.value = "";
                if (emailInput) emailInput.value = "";
                // Show tickets for this email immediately
                if (document.getElementById("check-email")) {
                    document.getElementById("check-email").value = data.email;
                    localStorage.setItem("last_checked_email", data.email);
                    checkTickets(data.email);
                }
            } else (0, $cP3LP.showToast)(result.error || "Failed to submit ticket", "error");
        } catch  {
            (0, $cP3LP.showToast)("Network error occurred during ticket submission.", "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    });
    // Check Status
    if (checkForm) checkForm.addEventListener("submit", (e)=>{
        e.preventDefault();
        const email = document.getElementById("check-email").value;
        localStorage.setItem("last_checked_email", email);
        checkTickets(email);
    });
    async function checkTickets(email) {
        activeEmail = email;
        try {
            (0, $cP3LP.showGlobalPreloader)("Fetching tickets...");
            const response = await fetch(`/api/support/tickets/public/list?email=${encodeURIComponent(email)}`);
            const tickets = await response.json();
            if (response.ok) {
                ticketResults.style.display = "block";
                ticketResults.innerHTML = tickets.length > 0 ? "" : '<p class="text-center" style="margin-top:20px;">No tickets found for this email.</p>';
                tickets.forEach((ticket)=>{
                    const item = createTicketItem(ticket);
                    item.onclick = ()=>openChat(ticket.id, ticket.subject);
                    ticketResults.appendChild(item);
                });
            } else (0, $cP3LP.showToast)("Could not fetch tickets.", "error");
        } catch  {
            // console.error("Network error during ticket fetch:", e);
            (0, $cP3LP.showToast)("Network error.", "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    }
    function createTicketItem(ticket) {
        const item = document.createElement("div");
        item.className = "ticket-item";
        const header = document.createElement("div");
        header.className = "header";
        const subjectEl = document.createElement("span");
        subjectEl.className = "subject";
        subjectEl.textContent = ticket.subject || "";
        const statusEl = document.createElement("span");
        statusEl.className = `status-badge status-${ticket.status || "open"}`;
        statusEl.textContent = ticket.status || "";
        header.append(subjectEl, statusEl);
        const meta = document.createElement("div");
        meta.style.cssText = "font-size:0.8rem; color:#8b949e;";
        meta.textContent = `ID: #${ticket.id} | Last updated: ${(0, $cP3LP.formatDate)(ticket.updated_at)}`;
        item.append(header, meta);
        return item;
    }
    async function openChat(ticketId, subject) {
        activeTicketId = ticketId;
        overlay.style.display = "flex";
        document.getElementById("overlay-subject").textContent = subject;
        loadMessages(ticketId);
    }
    async function loadMessages(ticketId) {
        try {
            (0, $cP3LP.showGlobalPreloader)("Loading messages...");
            const headers = {};
            let url = `/api/tickets/public/${ticketId}?email=${encodeURIComponent(activeEmail)}`;
            const response = await fetch(url, {
                headers: headers
            });
            const data = await response.json();
            if (response.ok) {
                chatMessages.innerHTML = "";
                data.messages.forEach((msg)=>{
                    const el = document.createElement("div");
                    el.className = `msg ${msg.is_admin_reply ? "admin" : "user"}`;
                    const contentEl = document.createElement("div");
                    contentEl.className = "msg-content";
                    contentEl.textContent = msg.message || "";
                    const timeEl = document.createElement("div");
                    timeEl.style.cssText = "font-size:0.6rem; margin-top:5px; opacity:0.7;";
                    timeEl.textContent = new Date(msg.created_at).toLocaleString();
                    el.append(contentEl, timeEl);
                    chatMessages.appendChild(el);
                });
                chatMessages.scrollTop = chatMessages.scrollHeight;
            } else (0, $cP3LP.showToast)("Failed to load messages.", "error");
        } catch  {
            // console.error("Network error loading messages:", e);
            (0, $cP3LP.showToast)("Network error loading messages.", "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    }
    replyForm.addEventListener("submit", async (e)=>{
        e.preventDefault();
        const message = document.getElementById("reply-text").value;
        const headers = {
            "Content-Type": "application/json"
        };
        let url = `/api/tickets/public/${activeTicketId}/reply`;
        if (!activeEmail) {
            // Guest reply needs an email
            (0, $cP3LP.showToast)("Email is required to reply.", "error");
            return;
        }
        try {
            (0, $cP3LP.showGlobalPreloader)("Sending reply...");
            const bodyData = {
                message: message
            };
            bodyData.email = activeEmail; // Always include email for guest replies
            const response = await fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(bodyData)
            });
            if (response.ok) {
                document.getElementById("reply-text").value = "";
                loadMessages(activeTicketId);
            } else (0, $cP3LP.showToast)("Failed to send reply.", "error");
        } catch  {
            // console.error("Network error sending reply:", e);
            (0, $cP3LP.showToast)("Network error sending reply.", "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    });
    // Close chat overlay
    document.querySelector(".chat-header button").addEventListener("click", ()=>{
        overlay.style.display = "none";
    });
});


//# sourceMappingURL=support_ticket.95daa9db.js.map
